<div class="gr-page">

  <div class="gr-page-header">
    <div class="gr-page-subtitle">{{ 'REMESAS.LIST.SUBTITLE' | translate }}</div>
    <button type="button" class="em-btn em-btn--primary" (click)="abrirCrear()">
      <mat-icon>add</mat-icon> {{ 'REMESAS.LIST.NUEVO_ENVIO' | translate }}
    </button>
  </div>

  <div class="gr-stats">
    <div class="gr-stat">
      <div class="gr-stat__value">{{ stats.total }}</div>
      <div class="gr-stat__label">{{ 'REMESAS.LIST.TOTAL' | translate }}</div>
    </div>
    <div class="gr-stat">
      <div class="gr-stat__value gr-stat__value--success">{{ stats.enviadas }}</div>
      <div class="gr-stat__label">{{ 'REMESAS.LIST.ENVIADAS' | translate }}</div>
    </div>
    <div class="gr-stat">
      <div class="gr-stat__value gr-stat__value--muted">{{ stats.borradores }}</div>
      <div class="gr-stat__label">{{ 'REMESAS.LIST.BORRADORES' | translate }}</div>
    </div>
    <div class="gr-stat">
      <div class="gr-stat__value gr-stat__value--amber">{{ stats.pendientesFirma || 0 }}</div>
      <div class="gr-stat__label">{{ 'REMESAS.LIST.PENDIENTES_FIRMA' | translate }}</div>
    </div>
    <div class="gr-stat">
      <div class="gr-stat__value gr-stat__value--amber">{{ stats.programadas }}</div>
      <div class="gr-stat__label">{{ 'REMESAS.LIST.PROGRAMADAS' | translate }}</div>
    </div>
  </div>

  <div class="gr-toolbar">
    <input type="text" class="em-input" [formControl]="filtroBusqueda"
           [placeholder]="'REMESAS.LIST.BUSCAR' | translate" />
    <select class="em-select" [formControl]="filtroEstado">
      <option value="todos">{{ 'REMESAS.LIST.TODOS_ESTADOS' | translate }}</option>
      <option value="ENVIADA">{{ 'REMESAS.LIST.ENVIADAS' | translate }}</option>
      <option value="BORRADOR">{{ 'REMESAS.LIST.BORRADORES' | translate }}</option>
      <option value="PENDIENTE_FIRMA">{{ 'REMESAS.LIST.PENDIENTES_FIRMA' | translate }}</option>
      <option value="PROGRAMADA">{{ 'REMESAS.LIST.PROGRAMADAS' | translate }}</option>
    </select>
    <select class="em-select" [formControl]="filtroTipoEnvio">
      <option [ngValue]="'todas'">{{ 'REMESAS.LIST.TODAS_TIPOLOGIAS' | translate }}</option>
      <option *ngFor="let t of tiposEnvio" [ngValue]="t.id">{{ tipologiaLabel(t) }}</option>
    </select>
  </div>

  <div class="gr-table-wrapper listado listado--cards-accent">
    <table mat-table [dataSource]="remesas" class="mat-elevation-z0">

      <ng-container matColumnDef="asunto">
        <th mat-header-cell *matHeaderCellDef>{{ 'REMESAS.LIST.ASUNTO' | translate }}</th>
        <td mat-cell *matCellDef="let r" [attr.data-label]="'REMESAS.LIST.ASUNTO' | translate" data-role="title" (click)="verDetalle(r)" class="gr-clickable">
          <div class="gr-asunto-cell">
            <div class="gr-asunto-title">{{ r.concepto }}</div>
            <div class="gr-asunto-preview" *ngIf="r.descripcion">{{ preview(r.descripcion) }}</div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="tipologia">
        <th mat-header-cell *matHeaderCellDef class="col-hide-sm">{{ 'REMESAS.LIST.TIPOLOGIA' | translate }}</th>
        <td mat-cell *matCellDef="let r" [attr.data-label]="'REMESAS.LIST.TIPOLOGIA' | translate" class="col-hide-sm">
          <span class="gr-badge"
                [class.gr-badge--comunicacion]="esComunicacion(r.tipoEnvio)"
                [class.gr-badge--notificacion]="esNotificacion(r.tipoEnvio)">
            {{ tipologiaLabel(r.tipoEnvio) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="destinatarios">
        <th mat-header-cell *matHeaderCellDef class="col-hide-xs">{{ 'REMESAS.LIST.DESTINATARIOS' | translate }}</th>
        <td mat-cell *matCellDef="let r" [attr.data-label]="'REMESAS.LIST.DESTINATARIOS' | translate" class="col-hide-xs">
          <div class="gr-dest-cell">
            <div class="gr-avatars">
              <span *ngFor="let d of r.destinatariosPreview" class="gr-avatar gr-avatar--sm" [title]="etiquetaDest(d)">
                {{ iniciales(d) }}
              </span>
            </div>
            <span class="gr-dest-count">{{ r.destinatariosCount }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef>{{ 'REMESAS.LIST.ESTADO' | translate }}</th>
        <td mat-cell *matCellDef="let r" [attr.data-label]="'REMESAS.LIST.ESTADO' | translate" data-role="status">
          <span class="gr-badge"
                [class.gr-badge--enviada]="r.estado === 'ENVIADA'"
                [class.gr-badge--borrador]="r.estado === 'BORRADOR'"
                [class.gr-badge--pendiente-firma]="r.estado === 'PENDIENTE_FIRMA'"
                [class.gr-badge--programada]="r.estado === 'PROGRAMADA'">
            {{ estadoLabel(r.estado) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef class="col-hide-sm">{{ 'REMESAS.LIST.FECHA' | translate }}</th>
        <td mat-cell *matCellDef="let r" [attr.data-label]="'REMESAS.LIST.FECHA' | translate" data-role="meta" class="col-hide-sm">
          <span *ngIf="r.estado === 'PROGRAMADA'" class="gr-fecha-prog">
            <mat-icon>schedule</mat-icon> {{ formatFecha(r.fechaProgramacion) }}
          </span>
          <span *ngIf="r.estado === 'PENDIENTE_FIRMA'" class="gr-muted">
            {{ formatFecha(r.fechaSolicitudFirma || r.fechaCreacion) }}
          </span>
          <span *ngIf="r.estado !== 'PROGRAMADA' && r.estado !== 'PENDIENTE_FIRMA'" class="gr-muted">
            {{ formatFecha(r.fechaEnvio || r.fechaCreacion) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef class="em-th-actions">{{ 'REMESAS.LIST.ACCIONES' | translate }}</th>
        <td mat-cell *matCellDef="let r" data-role="actions" class="em-td-actions">
          <div class="em-actions-wrap">
            <button type="button" class="em-icon-btn" [matTooltip]="'REMESAS.LIST.TOOLTIP_DETALLE' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" (click)="verDetalle(r)">
              <mat-icon>visibility</mat-icon>
            </button>
            <button type="button" class="em-icon-btn" [matTooltip]="'REMESAS.LIST.TOOLTIP_EDITAR' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" *ngIf="r.estado === 'BORRADOR'" (click)="abrirEditarBorrador(r.id, r.tipoEnvio)">
              <mat-icon>edit</mat-icon>
            </button>
            <button type="button" class="em-icon-btn" [matTooltip]="'REMESAS.LIST.TOOLTIP_FIRMAR_ENVIAR' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" *ngIf="r.estado === 'PENDIENTE_FIRMA' && esNotificacion(r.tipoEnvio)" (click)="verDetalle(r)">
              <mat-icon>draw</mat-icon>
            </button>
            <button type="button" class="em-icon-btn" [matTooltip]="'REMESAS.LIST.TOOLTIP_DUPLICAR' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" *ngIf="r.estado !== 'PENDIENTE_FIRMA'" (click)="duplicar(r)">
              <mat-icon>content_copy</mat-icon>
            </button>
            <button type="button" class="em-icon-btn em-icon-btn--danger" [matTooltip]="'REMESAS.LIST.TOOLTIP_ELIMINAR' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" *ngIf="r.estado === 'BORRADOR' || r.estado === 'PENDIENTE_FIRMA'" (click)="confirmarEliminar(r)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div class="gr-empty" *ngIf="!loading && remesas.length === 0">
      {{ 'REMESAS.LIST.VACIO' | translate }}
    </div>
  </div>

  <mat-paginator
    [length]="totalElements"
    [pageSize]="size"
    [pageIndex]="page"
    [pageSizeOptions]="[5, 10, 25, 100]"
    (page)="onPageChange($event)"
    showFirstLastButtons>
  </mat-paginator>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate" [fullScreen]="true" [name]="'gestion_remesas_spinner'">
  <p style="color: white">{{ mensajeSpinner }}</p>
</ngx-spinner>
